import React from "react";
import { NeoButton, NeoInput } from "../../../../../components/Common";
import {
    SWIM_EQUIPMENT_OPTIONS,
    SWIM_INTENSITY_ZONES,
    SWIM_SET_TYPES,
    SWIM_STROKES,
} from "../../domain/swimming/constants";
import { calculateSwimSetMeters } from "../../domain/swimming/calculations";

const equipmentListId = "swim-equipment-options";

const SwimmingSetRow = ({ baseName, setIndex, set, handleChange, onRemove, onSaveToLibrary }) => {
    const meters = calculateSwimSetMeters(set);

    return (
        <div className="swim-set-row">
            <div className="row align-items-end mx-0 gx-2">
                <div className="col-md-1 col-3">
                    <label className="font-size-10 mb-1 text-muted fw-bold d-block text-truncate">Séries</label>
                    <NeoInput type="number" name={`${baseName}.${setIndex}.reps`} value={set.reps || 1} onChange={handleChange} size="sm" min="1" />
                </div>
                <div className="col-md-auto col-1 text-center px-0">
                    <span className="font-weight-bold text-muted fw-bold font-size-12 d-inline-block pb-2">X</span>
                </div>
                <div className="col-md-1 col-4">
                    <label className="font-size-10 mb-1 text-muted fw-bold d-block text-truncate">Metros</label>
                    <NeoInput type="number" name={`${baseName}.${setIndex}.distance`} value={set.distance || ""} onChange={handleChange} size="sm" min="0" />
                </div>
                <div className="col-md-2 col-4">
                    <label className="font-size-10 mb-1 text-muted fw-bold d-block text-truncate">Tipo</label>
                    <NeoInput type="select" name={`${baseName}.${setIndex}.setType`} value={set.setType || ""} onChange={handleChange} size="sm">
                        <option value="">Selecione...</option>
                        {SWIM_SET_TYPES.map(type => <option key={type} value={type}>{type}</option>)}
                    </NeoInput>
                </div>
                <div className="col-md-2 col-6">
                    <label className="font-size-10 mb-1 text-muted fw-bold d-block text-truncate">Estilo</label>
                    <NeoInput type="select" name={`${baseName}.${setIndex}.style`} value={set.style || ""} onChange={handleChange} size="sm">
                        <option value="">Selecione...</option>
                        {SWIM_STROKES.map(style => <option key={style} value={style}>{style}</option>)}
                    </NeoInput>
                </div>
                <div className="col-md-1 col-6">
                    <label className="font-size-10 mb-1 text-muted fw-bold d-block text-truncate">Zona</label>
                    <NeoInput type="select" name={`${baseName}.${setIndex}.intensity`} value={set.intensity || ""} onChange={handleChange} size="sm">
                        <option value="">Zona</option>
                        {SWIM_INTENSITY_ZONES.map(zone => <option key={zone} value={zone}>{zone}</option>)}
                    </NeoInput>
                </div>
                <div className="col-md-2 col-6">
                    <label className="font-size-10 mb-1 text-muted fw-bold d-block text-truncate">Saída / intervalo</label>
                    <NeoInput type="text" name={`${baseName}.${setIndex}.interval`} value={set.interval || ""} onChange={handleChange} size="sm" placeholder="ex: 1:30 ou 15''" />
                </div>
                <div className="col-md-1 col-3 text-end">
                    <div className="swim-set-volume">{meters > 0 ? `${meters}m` : "-"}</div>
                </div>
                <div className="col-md-auto col-2 text-center px-1">
                    <NeoButton type="button" variant="soft-danger" size="sm" square icon="mdi-close" onClick={onRemove} className="w-100 swim-btn-delete" title="Remover set" />
                </div>
            </div>

            <div className="row mx-0 gx-2 mt-2">
                <div className="col-md-3">
                    <label className="font-size-10 mb-1 text-muted fw-bold d-block text-truncate">Material</label>
                    <NeoInput
                        type="text"
                        list={equipmentListId}
                        name={`${baseName}.${setIndex}.equipment`}
                        value={set.equipment || ""}
                        onChange={handleChange}
                        size="sm"
                        placeholder="Escolha ou digite outro"
                    />
                    <datalist id={equipmentListId}>
                        {SWIM_EQUIPMENT_OPTIONS.map(equipment => (
                            <option key={equipment} value={equipment} />
                        ))}
                    </datalist>
                </div>
                <div className="col-md-4">
                    <label className="font-size-10 mb-1 text-muted fw-bold d-block text-truncate">Foco técnico</label>
                    <NeoInput type="text" name={`${baseName}.${setIndex}.technicalFocus`} value={set.technicalFocus || ""} onChange={handleChange} size="sm" placeholder="ex: cotovelo alto, respiração 3/1" />
                </div>
                <div className="col-md-5">
                    <label className="font-size-10 mb-1 text-muted fw-bold d-block text-truncate">Observações</label>
                    <NeoInput type="text" name={`${baseName}.${setIndex}.description`} value={set.description || ""} onChange={handleChange} size="sm" placeholder="ex: manter técnica mesmo cansado" />
                </div>
            </div>
            {onSaveToLibrary && (
                <div className="d-flex justify-content-end mt-2">
                    <NeoButton
                        type="button"
                        variant="soft-primary"
                        size="sm"
                        icon="mdi-content-save-outline"
                        onClick={() => onSaveToLibrary(set)}
                    >
                        Salvar set na biblioteca
                    </NeoButton>
                </div>
            )}
        </div>
    );
};

export default SwimmingSetRow;
